
/**
 * Formats MOQ (Minimum Order Quantity) values for display
 * Will return "0" when MOQ is 0, null, or undefined
 */
export const formatMOQ = (moq?: number | null): string => {
  if (moq === 0 || moq === null || moq === undefined) {
    return "0";
  }
  
  return moq.toString();
};

/**
 * Returns the numeric value of MOQ, ensuring it's a number
 * Will return 0 when MOQ is null or undefined
 */
export const getMOQValue = (moq?: number | null): number => {
  if (moq === null || moq === undefined) {
    return 0;
  }
  
  return moq;
};

/**
 * Determines if a MOQ value should be considered as zero
 */
export const isMOQZero = (moq?: number | null): boolean => {
  return moq === 0 || moq === null || moq === undefined;
};

